import { Document } from '@bulthaup/api/db';
import { Button, Group, Stack, Text } from '@mantine/core';
import { IconEye } from '@tabler/icons-react';
import dayjs from 'dayjs';

import { SignatureRequestStatusBadge } from '../../-components/-signature-request-status-badge';
import { getUTDocumentUrl } from '../../../../../../services/upload';

interface DocumentHistoryModalProps {
  documents: Document[];
}

export function DocumentHistoryModal({ documents }: DocumentHistoryModalProps) {
  const filteredDocuments = documents.sort((a, b) => b.version - a.version);

  return (
    <Stack>
      {filteredDocuments.map(document => (
        <Group
          key={document.id}
          align="center"
          style={{
            width: '100%',
            borderLeft: '2px solid #e9ecef',
            paddingLeft: '12px',
            marginBottom: '8px',
          }}
        >
          <Stack gap={4} style={{ flex: 1 }}>
            <Group>
              <Text size="sm" fw={900}>
                {dayjs(document.createdAt).format('LL')}
              </Text>
            </Group>
            <Text size="sm" c="dimmed">
              {document.fileName}
            </Text>
            <SignatureRequestStatusBadge status={document.signatureStatus} />
            <Text size="xs" c="dimmed">
              Version {document.version}
            </Text>
          </Stack>
          <Button
            leftSection={<IconEye size={14} />}
            variant="outline"
            size="xs"
            onClick={() => {
              window.open(getUTDocumentUrl(document.utFileKey), '_blank');
            }}
          >
            Voir
          </Button>
        </Group>
      ))}
    </Stack>
  );
}
